import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const Asset = ShModel.extend({
  name: attr('string'),
  size: attr('number'), //
  storagePath: attr('string'), //
  type: attr('string'),
  createdAt: attr('date'),
  updatedAt: attr('date'),
  allow: attr(),

  //Relationships
  application: belongsTo('application', {
    async: false,
    inverse: 'assets',
  }),
  company: belongsTo('company', {
    async: false,
    inverse: 'assets',
  }),
  uploader: belongsTo('user', { async: false }),
  message: belongsTo('message', {
    async: false,
    inverse: 'assets',
  }),
  uriCollection: belongsTo('uricollection', { async: false }),
});

export default Asset;
